let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i1ge2")).then(() => parcelRequire('aY6MW'));